"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useResponseBoxStyles = ({ type, hasDescription }) => {
    const theme = (0, material_1.useTheme)();
    const mainContainer = Object.assign({ display: 'flex', flexDirection: 'row', gap: theme.spacing(1.6), padding: `${theme.spacing(2)} ${theme.spacing(3)}`, justifyContent: 'center', textAlign: 'left' }, (hasDescription ? { alignItems: 'center' } : { alignItems: 'flex-start' }));
    const textContainer = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        gap: theme.spacing(0.5),
    };
    const icon = Object.assign({ '& svg ': {
            height: theme.spacing(4),
            width: theme.spacing(4),
            color: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
        } }, (type !== 'pending' && { height: theme.spacing(4), width: theme.spacing(4) }));
    const message = {
        fontSize: theme.qlub.typography.headline_sm.fontSize,
        fontWeight: theme.qlub.typography.tip_single_line_percentage.fontWeight,
        color: theme.palette.text.primary,
    };
    const description = Object.assign(Object.assign(Object.assign(Object.assign({ fontWeight: theme.typography.fontWeightMedium }, theme.typography.caption), (type === 'success' && { color: theme.qlub.palette.success.main })), (type === 'error' && { color: theme.palette.error.main })), (type === 'partial' && { color: '#558B2F' }));
    return {
        mainContainer,
        textContainer,
        icon,
        message,
        description,
    };
};
exports.default = useResponseBoxStyles;
